export default __webpack_public_path__ + "static/media/slots.57318261.svg";